import { scaleOrdinal } from 'd3-scale';
import {
  schemeCategory10,
  schemeAccent,
  schemeDark2,
  schemePaired,
  schemePastel1,
  schemePastel2,
  schemeSet1,
  schemeSet2,
  schemeSet3,
} from 'd3-scale-chromatic';

const schemes = {
  schemeCategory10,
  schemeAccent,
  schemeDark2,
  schemePaired,
  schemePastel1,
  schemePastel2,
  schemeSet1,
  schemeSet2,
  schemeSet3,
  // TODO: there should be a plugin system to define custom schemes beyond d3
  // defaults.
  atlas: [
    '#e3e8eb',
    '#fbb12d',
    '#ee2b75',
    '#b4cd23',
    '#009ddc',
    '#ff641e',
    '#b2b8be',
  ],
};

export default (conf) => {
  const scheme = Array.isArray(conf.scheme)
    ? conf.scheme
    : schemes[conf.scheme] || schemeCategory10;
  const scale = scaleOrdinal(scheme);
  if (conf.domain) scale.domain(conf.domain);

  return {
    id: conf.id,
    field: conf.field,
    options: conf,
    transformer: (domain) => {
      const transformer = scale.copy();
      if (domain !== undefined) transformer.domain(domain);
      return transformer;
    },
  };
};
